exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1ockQXTUn9V3_Gil8VCmMz {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 0.8em;\n}\n\n._1ockQXTUn9V3_Gil8VCmMz tbody:first-child tr td {\n  border: 0;\n}\n\n._38FUTtZkY05lxEUQk52kBt tbody tr td {\n  border: 0;\n}\n\n._1ockQXTUn9V3_Gil8VCmMz tr td {\n  white-space: nowrap;\n}\n\n._1ockQXTUn9V3_Gil8VCmMz tr td:nth-child(4) {\n  font-family: Open Sans,sans-serif;\n  white-space: normal;\n}\n\n._20GPz3FHoTn4L3wK93GH3t > tr:first-child {\n  border-bottom: none;\n}\n\n._20GPz3FHoTn4L3wK93GH3t > tr:last-child {\n  border-top: none;\n}\n\n._20GPz3FHoTn4L3wK93GH3t > :last-child td {\n  padding-left: 2em;\n}\n\n._3tnhPqB56Y0DJd9AJPShql {\n  color: red;\n  vertical-align: super;\n  font-size: 0.7em;\n}\n\n._26I69MYyHcWgioDtmmU0Xj {\n  padding-left: 0;\n  list-style-position: inside;\n}\n\n._1ockQXTUn9V3_Gil8VCmMz tbody table {\n  background-color: initial !important;\n}\n", ""]);

// exports
exports.locals = {
	"parentTable": "_1ockQXTUn9V3_Gil8VCmMz",
	"childTable": "_38FUTtZkY05lxEUQk52kBt",
	"joined": "_20GPz3FHoTn4L3wK93GH3t",
	"required": "_3tnhPqB56Y0DJd9AJPShql",
	"list": "_26I69MYyHcWgioDtmmU0Xj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./src/components/SchemaTable/styles.css
// module id = 17
// module chunks = 0 1 2